module.exports = function (async = true) {
	if (!async) return objectFit();

	setTimeout(function () {
		requestAnimationFrame(function () {
		    objectFit();
		});
	}, 0)
};

function objectFit() {
	if ('objectFit' in document.documentElement.style === false) {
		let container = document.getElementsByClassName('object-fit');
		let image;

		for (var i = 0; i < container.length; i++) {
			image = container[i].querySelector("img");

			if (image.style.display !== "none") {
				image.style.display = 'none';
				container[i].style.backgroundSize = 'cover';
				container[i].style.backgroundImage = 'url(' + image.src + ')';
				container[i].style.backgroundPosition = 'center center';
				container[i].style.backgroundRepeat = 'no-repeat';
			}
		}
	}
}
